var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLayer7Day(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 3001 1688",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsSerif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Layer-7",
    serifId: "Layer 7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3000,-0l-3000,-0l0.002,1687.6l3000,0l-0.002,-1687.6Z",
    style: {
      fill: "url(#_Linear1)"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "clouds"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1855.61,233.554c1.512,0.173 2.627,1.496 2.541,3.016c-0.087,1.52 -1.345,2.708 -2.867,2.708c-101.921,-0.038 -277.846,-0.104 -388.134,-0.145c-2.81,0.003 -5.132,-2.192 -5.289,-4.998c-0.156,-2.806 1.908,-5.245 4.701,-5.554c23.74,-3.424 47.604,-6.406 72.12,-6.532c43.95,-0.226 87.875,6.41 131.82,7.058c43.289,0.638 87.355,-4.932 130.571,-2.263c18.653,1.152 36.229,4.527 54.489,6.705c0.016,0.002 0.032,0.003 0.048,0.005Z",
    style: {
      fill: "#fff",
      fillOpacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1571.74,172.1c1.488,0.229 2.548,1.565 2.433,3.066c-0.115,1.501 -1.367,2.66 -2.872,2.659c-76.966,-0.038 -209.566,-0.104 -292.806,-0.145c-2.776,0.001 -5.081,-2.143 -5.28,-4.912c-0.199,-2.769 1.775,-5.221 4.523,-5.617c17.982,-3.43 36.058,-6.428 54.628,-6.554c33.196,-0.226 66.374,6.409 99.567,7.057c32.697,0.639 65.982,-4.932 98.625,-2.263c14.089,1.153 27.365,4.528 41.157,6.705c0.008,0.002 0.016,0.003 0.025,0.004Z",
    style: {
      fill: "#fff",
      fillOpacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1269.78,246.509c2.063,0.286 3.552,2.121 3.407,4.198c-0.144,2.078 -1.872,3.69 -3.954,3.689c-126.538,-0.056 -350.371,-0.154 -476.505,-0.21c-2.786,-0.005 -5.091,-2.17 -5.271,-4.95c-0.18,-2.78 1.827,-5.224 4.589,-5.588c35.35,-6.141 70.665,-12.759 107.218,-12.98c51.386,-0.311 102.744,8.828 154.124,9.72c50.614,0.88 102.136,-6.792 152.665,-3.116c21.808,1.587 42.359,6.235 63.708,9.234c0.006,0.001 0.012,0.002 0.019,0.003Z",
    style: {
      fill: "#fff",
      fillOpacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2823.83,445.987c2.055,0.61 3.35,2.637 3.04,4.758c-0.309,2.121 -2.128,3.693 -4.271,3.693c-109.152,-0.029 -519.697,-0.19 -724.75,-0.271c-2.759,-0.005 -5.051,-2.13 -5.265,-4.881c-0.214,-2.751 1.721,-5.204 4.446,-5.637c17.351,-2.745 34.522,-5.911 51.334,-9.333c29.442,-5.993 58.222,-17.446 88.707,-18.152c31.948,-0.74 61.236,14.773 92.277,18.92c73.408,9.808 141.969,-26.068 208.841,-12.214c73.415,15.21 131.966,-2.378 181.459,-0.475c27.887,1.071 74.951,14.457 104.182,23.592Z",
    style: {
      fill: "#fff",
      fillOpacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M491.537,472.203c2.027,0.644 3.281,2.67 2.955,4.771c-0.326,2.101 -2.136,3.651 -4.262,3.65c-103.439,-0.026 -490.23,-0.191 -490.23,-0.191l0,-36.242c7.558,-1.86 14.52,-3.139 20.643,-3.293c27.32,-0.688 54.448,11.644 80.992,15.497c62.773,9.114 96.401,-38.806 153.585,-25.932c62.78,14.133 106.598,18.624 148.921,20.391c23.315,0.974 62.308,12.886 87.396,21.349Z",
    style: {
      fill: "#fff",
      fillOpacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3000,713.555l-0,51.085c-0,0 -243.783,-0.104 -372.271,-0.159c-2.786,0.003 -5.097,-2.154 -5.285,-4.934c-0.189,-2.779 1.81,-5.228 4.571,-5.601c22.644,-4.336 45.267,-8.305 67.671,-7.9c37.677,0.68 78.954,-20.379 105.023,-21.035c27.319,-0.687 54.447,11.644 80.991,15.498c49.216,7.145 80.516,-20.768 119.3,-26.954Z",
    style: {
      fill: "#fff",
      fillOpacity: 0.5
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "birds"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M727.055,869.698c-0.203,0.038 -0.406,-0.069 -0.489,-0.259c-0.082,-0.19 -0.023,-0.412 0.143,-0.535c2.763,-1.883 8.797,-4.903 15.162,-0.856c-0,0 6.16,-4.694 14.902,0.974c0.212,0.133 0.311,0.39 0.242,0.631c-0.068,0.24 -0.288,0.406 -0.538,0.408c-2.899,-0.022 -8.532,0.19 -12.157,2.075c-1.531,0.886 -3.431,0.833 -4.91,-0.136c-2.557,-1.483 -6.786,-3.28 -12.355,-2.302Z",
    style: {
      fill: "#bdf6ff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M764.555,890.531c-0.203,0.038 -0.406,-0.069 -0.489,-0.259c-0.082,-0.189 -0.023,-0.411 0.143,-0.534c2.763,-1.884 8.797,-4.903 15.162,-0.856c-0,-0 6.16,-4.695 14.902,0.974c0.212,0.132 0.311,0.389 0.242,0.63c-0.068,0.24 -0.288,0.407 -0.538,0.408c-2.899,-0.022 -8.532,0.19 -12.157,2.076c-1.531,0.885 -3.431,0.832 -4.91,-0.137c-2.557,-1.482 -6.786,-3.28 -12.355,-2.302Z",
    style: {
      fill: "#bdf6ff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M686.395,893.893c-0.204,0.038 -0.407,-0.069 -0.49,-0.259c-0.082,-0.19 -0.023,-0.412 0.143,-0.535c2.763,-1.883 8.797,-4.903 15.162,-0.856c-0,0 6.16,-4.694 14.902,0.974c0.212,0.133 0.311,0.39 0.242,0.63c-0.068,0.241 -0.288,0.407 -0.538,0.409c-2.899,-0.023 -8.532,0.19 -12.157,2.075c-1.531,0.886 -3.431,0.833 -4.91,-0.136c-2.557,-1.483 -6.786,-3.281 -12.354,-2.302Z",
    style: {
      fill: "#bdf6ff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M734.048,908.476c-0.203,0.038 -0.406,-0.069 -0.489,-0.259c-0.083,-0.189 -0.024,-0.411 0.143,-0.534c2.762,-1.884 8.796,-4.903 15.161,-0.856c0,-0 6.161,-4.695 14.903,0.973c0.212,0.133 0.31,0.39 0.242,0.631c-0.069,0.24 -0.288,0.407 -0.538,0.408c-2.899,-0.022 -8.533,0.19 -12.158,2.076c-1.531,0.885 -3.43,0.832 -4.91,-0.137c-2.556,-1.482 -6.785,-3.28 -12.354,-2.302Z",
    style: {
      fill: "#bdf6ff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M811.131,869.698c-0.203,0.038 -0.406,-0.069 -0.489,-0.259c-0.083,-0.19 -0.023,-0.412 0.143,-0.535c2.763,-1.883 8.797,-4.903 15.162,-0.856c-0,0 6.16,-4.694 14.902,0.974c0.212,0.133 0.311,0.39 0.242,0.631c-0.069,0.24 -0.288,0.406 -0.538,0.408c-2.899,-0.022 -8.532,0.19 -12.157,2.075c-1.531,0.886 -3.431,0.833 -4.911,-0.136c-2.556,-1.483 -6.785,-3.28 -12.354,-2.302Z",
    style: {
      fill: "#bdf6ff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M811.131,905.114c-0.203,0.039 -0.406,-0.069 -0.489,-0.258c-0.083,-0.19 -0.023,-0.412 0.143,-0.535c2.763,-1.884 8.797,-4.903 15.162,-0.856c-0,-0 6.16,-4.695 14.902,0.974c0.212,0.133 0.311,0.39 0.242,0.63c-0.069,0.241 -0.288,0.407 -0.538,0.408c-2.899,-0.022 -8.532,0.191 -12.157,2.076c-1.531,0.886 -3.431,0.833 -4.911,-0.136c-2.556,-1.483 -6.785,-3.281 -12.354,-2.303Z",
    style: {
      fill: "#bdf6ff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M859.048,887.169c-0.203,0.039 -0.406,-0.069 -0.489,-0.258c-0.083,-0.19 -0.024,-0.412 0.143,-0.535c2.762,-1.884 8.796,-4.903 15.161,-0.856c0,-0 6.161,-4.695 14.903,0.974c0.212,0.133 0.31,0.39 0.242,0.63c-0.069,0.241 -0.288,0.407 -0.538,0.408c-2.899,-0.022 -8.533,0.191 -12.158,2.076c-1.531,0.886 -3.43,0.833 -4.91,-0.136c-2.556,-1.483 -6.785,-3.281 -12.354,-2.303Z",
    style: {
      fill: "#bdf6ff"
    }
  }))), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "_Linear1",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(16.6667,-2187.5,2187.5,16.6667,2175,2133.33)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#ecfdff",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    style: {
      stopColor: "#e2fcff",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    style: {
      stopColor: "#caf9ff",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#b0f5ff",
      stopOpacity: 1
    }
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLayer7Day);
export default __webpack_public_path__ + "static/media/layer7-day.4ae793542180ae3c787430c28e83776f.svg";
export { ForwardRef as ReactComponent };